/* eslint-disable no-use-before-define */
import { isFunction } from 'formik'
import React from 'react'
import { ajax, usePrevious, getEventHandlers, cleanObject, show, arrayFrom, stringFrom, track, isObject } from '../../twd'
import { getSearchParams } from './search-params'
import { getGenericSearch } from './generic-search'

const $ = global.$

const Modes = {
    'NONE': 'none',
    'SHOW_LAST': 'show_last',
    'SEARCH': 'search',
}

export default () => {
    const inputRef = React.useRef()
    const resultRef = React.useRef()
    const [keyword, setKeyword] = React.useState(null)
    const [mode, setMode] = React.useState(Modes.NONE)
    const prevMode = usePrevious(mode)

    var lock = false
    const onFocus = (e) => {
        onChange(e)
    }
    const onClear = () => {
        lock = true
        let e = inputRef.current
        e.value = ''
        e.focus()
    }

    const onBlur = () => {
        setTimeout(() => {
            const inputEl = inputRef.current
            if (resultRef.current.getAttribute('mouse-on-result')) {
                inputEl.focus()
                return
            }

            if (lock) {
                lock = false
                return
            }

            setKeyword('')
            setMode(Modes.NONE)

            const rs = $(inputEl).closest('.container').find(':focusable').get()
            const n = rs.indexOf(inputEl)
            const a = rs[inputEl.shiftKeyed ? n-1 : n+1]
            if (a) a.focus()

        }, 250)
    }

    const onChange = (e) => {
        let txt = e.target.value
        setKeyword(txt ? txt.toUpperCase() : txt)
        setMode(txt ? Modes.SEARCH : Modes.SHOW_LAST)
    }

    const onKeyPress = (e) => {
        let key = e.keyCode || e.key || e.which

        if (!(key===13 || key === 'Enter')) return

        e.preventDefault()

        let el = resultRef.current
        let a = $(el).find('.auto-suggest-menu-item.focus')[0]
        if (a) {
            let i = getEventHandlers(a).item
            if (!i) return

            e.target.blur()
            onSearch(i)
            return
        }

        let txt = stringFrom(e.target.value).trim()
        if (!txt) return

        {
            let gsp = getGenericSearch(txt.toLowerCase())
            if (gsp && !gsp.error) {
                e.target.blur()
                if (isObject(gsp)) {
                    return onSearch({ searchParams: gsp })
                }

                if (isFunction(gsp)) {
                    return gsp()
                }
                return
            }
        }

        e.persist()

        setTimeout(async () => {
            try {
                let { data } = await ajax({
                    url: '/esb/portfolio/securitysuggestions',
                    method: 'GET',
                    params: {
                        keyword: txt.trim(),
                        page:1,
                        start:0,
                        limit:10
                    }
                })
                let a = await data
                let rs = arrayFrom(a.securities)
                let ps = getSearchParams(rs, txt)
                let k = txt.trim().toLowerCase()
                let idx = Math.max(ps.findIndex(a => isMatch(a, k)), 0)

                let sp = ps[idx]
                if (!sp) return

                track('Bond Resource Center Search', { search_term: txt.trim() })

                e.target.blur()
                onSearch(sp)
            } catch(e) {
            }
        })
    }

    const isMatch = (a, k) => {
        return (a.symbol && a.symbol.toLowerCase()===k)
            || (a.issue && a.issue.toLowerCase()===k)
            || (a.cusip && a.cusip.toLowerCase()===k)
    }

    const onKeyDown = (e) => {
        let key = e.keyCode || e.key || e.which

        const isEsc = key === 27 || key==='Escape'
        const isTab = key===9 || key==='Tab'
        const isExit = mode !== Modes.SEARCH && (isEsc || isTab)
        const inputEl = inputRef.current
        inputEl.shiftKeyed = e.shiftKey

        if (isExit) {
            e.preventDefault()
            resultRef.current.removeAttribute('mouse-on-result')
            inputEl.blur()

            return
        }

        if (mode !== Modes.SEARCH) return

        if (isEsc) {
            inputEl.value = ''
            setKeyword('')
            setMode(Modes.SHOW_LAST)
            return
        }

        if (key === 38 || key==='ArrowUp') {
            let el = resultRef.current

            let a = $(el)
                .find('.auto-suggest-menu-item.focus')
                .removeClass('focus')
                .prev('.auto-suggest-menu-item')
                .addClass('focus')
            if (a.length>0) return

            $(el).find('.auto-suggest-menu-item')
                .last()
                .addClass('focus')
            return
        }

        if (key === 40 || key==='ArrowDown') {
            let el = resultRef.current

            let a = $(el)
                .find('.auto-suggest-menu-item.focus')
                .removeClass('focus')
                .next('.auto-suggest-menu-item')
                .addClass('focus')
            if (a.length>0) return

            $(el).find('.auto-suggest-menu-item')
                .first()
                .addClass('focus')
            return
        }
    }

    const onSearch = ({searchParams}) => {
        if (resultRef.current) {
            resultRef.current.removeAttribute('mouse-on-result')
        }

        setMode(Modes.NONE)
        show('offerings', {
            searchParams: Object.assign({
                offeringType: ['ask-side'],
                origin:'global-search',
            }, cleanObject(searchParams)),
            _ts: Date.now()
        })
    }

    return {
        mode, prevMode, Modes, keyword, onSearch,
        inputRef, resultRef,
        onFocus, onClear, onBlur, onKeyPress, onKeyDown, onChange}
}



// WEBPACK FOOTER //
// ./src/header/global-search/use-global-search.js